import { render, staticRenderFns } from "./CreateConfiguration.vue?vue&type=template&id=9488ce4a&scoped=true"
import script from "./CreateConfiguration.vue?vue&type=script&lang=js"
export * from "./CreateConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9488ce4a",
  null
  
)

export default component.exports